<template>
    <div class="bcg">
        <div>
            <img src="../../assets/404.png" alt="" style="width:40%">
        </div>
        <div>
            <p>該網頁無法正常訪問！</p>
            <p>404:網頁不存在，不如返回上一頁或者刷新頁面試試吧</p>
            <p ><a @click="goLast">返回上一頁></a></p>
            <p ><a @click="goFirst()">回到首頁></a></p>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{

            }
        },
        methods:{
            goFirst(){
                this.$router.push('/dashboard')
            },
            goLast(){
                this.$router.go(-1)
            }
        }
    }
</script>
<style scoped>
    *{
        user-select: none;
    }
    .bcg {
        padding:12px 0px;
        /*width: 50%;*/
    }
    .bcg div{
        width: 100%;
    }
    .bcg div{
        text-align: center;
    }
    /*.bcg div:nth-child(2){*/
    /*   padding:200px 0px;*/
    /*}*/
    .bcg p:nth-child(1){
        font-size:30px;
        font-weight: bold;
        padding:15px 0px;
    }
    .bcg p:nth-child(2) a,.bcg p:nth-child(3) a{
        cursor:pointer
    }
    .bcg p a{
        color: #00b3ee;
    }
</style>



// WEBPACK FOOTER //
// src/views/notFond/notfond.vue